"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var isServer = typeof window === 'undefined';
var parsedBettingOptions;
try {
    var lBettingOptions = localStorage.getItem('bettingOptions');
    if (lBettingOptions) {
        parsedBettingOptions = JSON.parse(lBettingOptions);
    }
}
catch (_a) { }
function getBettingOptions() {
    if (isServer) {
        return globalThis.bettingOptionsSSR;
    }
    var _a = window.bettingOptions, url = _a.url, selectedSportIds = _a.selectedSportIds, sportIds = _a.sportIds, features = _a.features;
    if (!selectedSportIds || selectedSportIds.length === 0) {
        window.bettingOptions.selectedSportIds = sportIds;
    }
    if (!parsedBettingOptions) {
        return window.bettingOptions;
    }
    return __assign(__assign(__assign({}, window.bettingOptions), parsedBettingOptions), { url: __assign(__assign({}, url), parsedBettingOptions.url), features: __assign(__assign({}, features), parsedBettingOptions.features) });
}
exports.default = getBettingOptions;
//# sourceMappingURL=getBettingOptions.js.map